import axios from 'axios'
import router from '../../router/index'
import jwt_decode from 'jwt-decode'



const url = 'http://0.0.0.0:8000'

const state = {
  jwt: localStorage.getItem('t'),
  usuario: {},
  endpoints: {
    obtainJWT: url + '/auth/obtain_token/',
    refreshJWT: url + '/auth/refresh_token',
  }
}

const mutations = {
  updateToken(state, newToken) {
    state.jwt = newToken;
    localStorage.setItem('t', newToken);
    state.usuario = jwt_decode(state.jwt)
    state.jwt = localStorage.getItem('t')
    router.push({name: 'Dashboard'})
  },
  removeToken(state) {
    localStorage.removeItem('t');
    state.jwt = null;
  }
}

const actions = {

  obtainToken(context, val) {
    const payload = {
      username: val.username,
      password: val.password
    }


    axios.post(state.endpoints.obtainJWT, payload)
      .then((response) => {
        this.commit('updateToken', response.data.token);
      })
      .catch((error) => {
        console.log(error);
      })
    console.log('servicio')
    console.log(state.jwt)
  },
  refreshToken() {
    const payload = {
      token: state.jwt
    }
    axios.post(state.endpoints.refreshJWT, payload)
      .then((response) => {
        this.commit('updateToken', response.data.token)
      })
      .catch((error) => {
        console.log(error)
      })
  },
  inspectToken() {
    // WE WILL ADD THIS LATER
  }
}

const getters = {
  usuario: (state) => state.usuario
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/storage/modules/login.js